// Every pane must answer the host's jQuery calls; a missing one silently no-ops behind its optional chaining.
export default {
  data() {
    return {
      params: {},
    };
  },
  methods: {
    // Replaces the object rather than mutating it so ExternalContentView's watcher fires.
    mergeParams(next) {
      this.params = { ...this.params, ...next };
    },

    setParams(next) {
      this.mergeParams(next);
    },

    clearSelection() {
      this.$refs.content?.clearSelection();
    },

    setMultiple(value) {
      this.$refs.content?.setMultiple(value);
    },

    reload(page = 1) {
      return this.$refs.content?.fetchItems(page);
    },

    totalCount() {
      return this.$refs.content?.totalRows ?? 0;
    },
  },
};
